import { render, staticRenderFns } from "./elec-energy-pie.vue?vue&type=template&id=45163cdc&scoped=true&"
import script from "./elec-energy-pie.vue?vue&type=script&lang=js&"
export * from "./elec-energy-pie.vue?vue&type=script&lang=js&"
import style0 from "./elec-energy-pie.vue?vue&type=style&index=0&id=45163cdc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45163cdc",
  null
  
)

export default component.exports